import React from 'react';
import moment from 'moment-timezone';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import TimeZoneAgnosticBigCalendar from 'components/Schedule/TimeZoneAgnosticBigCalendar';
import CalendarUtils from 'services/CalendarUtils';
import Event from 'components/Schedule/Events';

var DnDCalendar = withDragAndDrop(TimeZoneAgnosticBigCalendar, {
  backend: false,
});

const DragAndDropCalendar = ({
  className,
  events = [],
  physicianId,
  date = moment(),
  moveEvent,
  onEventClick,
  draggable,
}) => {
  let selectedDate = date.clone().startOf('day').add(12, 'h');

  let min = moment();
  min.hour(8);
  min.minute(0);

  let max = moment();
  max.hour(19);
  max.minute(59);

  return (
    <div className={className}>
      <DnDCalendar
        timeZoneName={CalendarUtils.getTargetTimezone()}
        events={events}
        components={{
          event: ({ event }) => <Event event={event} onClick={onEventClick} />,
        }}
        step={15}
        timeslots={4}
        defaultView="day"
        toolbar={false}
        min={CalendarUtils.momentToDate(min)}
        max={CalendarUtils.momentToDate(max)}
        defaultDate={CalendarUtils.momentToDate(selectedDate)}
        startAccessor="start"
        endAccessor="end"
        onEventDrop={({ event, start, end }) => {
          moveEvent(physicianId, event, start);
        }}
        date={CalendarUtils.momentToDate(selectedDate)}
        onNavigate={() => {}}
        draggableAccessor={(event) =>
          draggable !== undefined ? draggable && event.draggable : false
        }
      />
    </div>
  );
};

export default DragAndDropCalendar;
